import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBreadcrumbsDivider } from 'vuetify/lib/components/VBreadcrumbs';
import { VBreadcrumbsItem } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "dashboard container" },
    [
      _c(
        VBreadcrumbs,
        [
          _c(
            VBreadcrumbsItem,
            { attrs: { exact: true, to: { name: "home", params: {} } } },
            [_vm._v("Home")]
          ),
          _c(VBreadcrumbsDivider, [_vm._v("/")]),
          _c(
            VBreadcrumbsItem,
            {
              attrs: {
                exact: true,
                to: { name: "inventoryReservation", params: {} },
              },
            },
            [_vm._v(" Inventory Reservations ")]
          ),
          _c(VBreadcrumbsDivider, [_vm._v("/")]),
          _c(VBreadcrumbsItem, { attrs: { active: "" } }, [
            _vm._v(" Dashboard "),
          ]),
        ],
        1
      ),
      _vm.loading
        ? _c(VProgressLinear, {
            staticClass: "mb-4",
            attrs: { indeterminate: "", color: "primary" },
          })
        : _vm._e(),
      !_vm.loading
        ? [
            _c(
              VRow,
              { staticClass: "mb-4" },
              [
                _c(
                  VCol,
                  { attrs: { cols: "12", sm: "6", md: "3" } },
                  [
                    _c(
                      VCard,
                      { staticClass: "summary-card", attrs: { outlined: "" } },
                      [
                        _c(
                          VCardTitle,
                          { staticClass: "pb-1" },
                          [
                            _c(
                              VIcon,
                              { staticClass: "mr-2", attrs: { color: "blue" } },
                              [_vm._v("mdi-bookmark-multiple")]
                            ),
                            _c("span", { staticClass: "text-subtitle-1" }, [
                              _vm._v("Active Reservations"),
                            ]),
                          ],
                          1
                        ),
                        _c(VCardText, [
                          _c(
                            "span",
                            { staticClass: "text-h4 font-weight-bold" },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.formatNumber(_vm.activeReservationCount)
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  VCol,
                  { attrs: { cols: "12", sm: "6", md: "3" } },
                  [
                    _c(
                      VCard,
                      { staticClass: "summary-card", attrs: { outlined: "" } },
                      [
                        _c(
                          VCardTitle,
                          { staticClass: "pb-1" },
                          [
                            _c(
                              VIcon,
                              {
                                staticClass: "mr-2",
                                attrs: { color: "orange" },
                              },
                              [_vm._v("mdi-weight")]
                            ),
                            _c("span", { staticClass: "text-subtitle-1" }, [
                              _vm._v("Total Reserved Weight"),
                            ]),
                          ],
                          1
                        ),
                        _c(VCardText, [
                          _c(
                            "span",
                            { staticClass: "text-h4 font-weight-bold" },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.formatNumber(_vm.totalReservedWeight)
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                          _c("span", { staticClass: "text-caption ml-1" }, [
                            _vm._v("kg"),
                          ]),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  VCol,
                  { attrs: { cols: "12", sm: "6", md: "3" } },
                  [
                    _c(
                      VCard,
                      { staticClass: "summary-card", attrs: { outlined: "" } },
                      [
                        _c(
                          VCardTitle,
                          { staticClass: "pb-1" },
                          [
                            _c(
                              VIcon,
                              { staticClass: "mr-2", attrs: { color: "red" } },
                              [_vm._v("mdi-alert-circle")]
                            ),
                            _c("span", { staticClass: "text-subtitle-1" }, [
                              _vm._v("Open Issues"),
                            ]),
                          ],
                          1
                        ),
                        _c(VCardText, [
                          _c(
                            "span",
                            { staticClass: "text-h4 font-weight-bold" },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.formatNumber(_vm.openIssueCount)) +
                                  " "
                              ),
                            ]
                          ),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  VCol,
                  { attrs: { cols: "12", sm: "6", md: "3" } },
                  [
                    _c(
                      VCard,
                      { staticClass: "summary-card", attrs: { outlined: "" } },
                      [
                        _c(
                          VCardTitle,
                          { staticClass: "pb-1" },
                          [
                            _c(
                              VIcon,
                              {
                                staticClass: "mr-2",
                                attrs: { color: "amber" },
                              },
                              [_vm._v("mdi-clock-alert")]
                            ),
                            _c("span", { staticClass: "text-subtitle-1" }, [
                              _vm._v("Stale Reservations"),
                            ]),
                          ],
                          1
                        ),
                        _c(VCardText, [
                          _c(
                            "span",
                            { staticClass: "text-h4 font-weight-bold" },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.formatNumber(_vm.staleReservationCount)
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                          _c("span", { staticClass: "text-caption ml-1" }, [
                            _vm._v("> 7 days pending"),
                          ]),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm.openIssueCount > 0
              ? _c(
                  VAlert,
                  {
                    staticClass: "mb-4",
                    attrs: { type: "warning", prominent: "", outlined: "" },
                  },
                  [
                    _c(
                      VRow,
                      { attrs: { align: "center" } },
                      [
                        _c(VCol, { staticClass: "grow" }, [
                          _vm._v(
                            " There " +
                              _vm._s(_vm.openIssueCount === 1 ? "is" : "are") +
                              " "
                          ),
                          _c("strong", [_vm._v(_vm._s(_vm.openIssueCount))]),
                          _vm._v(
                            " open inventory " +
                              _vm._s(
                                _vm.openIssueCount === 1 ? "issue" : "issues"
                              ) +
                              " requiring attention (NEEDS_REVIEW or BACKORDER). "
                          ),
                        ]),
                        _c(
                          VCol,
                          { staticClass: "shrink" },
                          [
                            _c(
                              VBtn,
                              {
                                attrs: { color: "warning", outlined: "" },
                                on: { click: _vm.navigateToIssues },
                              },
                              [_vm._v(" View Issues ")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _c(
              VCard,
              { attrs: { outlined: "" } },
              [
                _c(VCardTitle, [_vm._v(" Product Reservation Overview ")]),
                _c(
                  VCardText,
                  [
                    _c(VDataTable, {
                      staticClass: "elevation-0",
                      attrs: {
                        headers: _vm.headers,
                        items: _vm.productReservationRows,
                        "items-per-page": 10,
                        "item-key": "productId",
                        "hide-default-header":
                          !_vm.productReservationRows ||
                          _vm.productReservationRows.length < 1,
                        "hide-default-footer":
                          !_vm.productReservationRows ||
                          _vm.productReservationRows.length < 1,
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "item.totalAvailable",
                            fn: function ({ item }) {
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.formatNumber(item.totalAvailable)
                                    ) +
                                    " "
                                ),
                              ]
                            },
                          },
                          {
                            key: "item.totalReserved",
                            fn: function ({ item }) {
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.formatNumber(item.totalReserved)
                                    ) +
                                    " "
                                ),
                              ]
                            },
                          },
                          {
                            key: "item.freeAvailable",
                            fn: function ({ item }) {
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.formatNumber(item.freeAvailable)
                                    ) +
                                    " "
                                ),
                              ]
                            },
                          },
                          {
                            key: "item.reservationPercent",
                            fn: function ({ item }) {
                              return [
                                _c(
                                  VChip,
                                  {
                                    attrs: {
                                      color: _vm.getReservationColor(
                                        item.reservationPercent
                                      ),
                                      dark: "",
                                      small: "",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          item.reservationPercent.toFixed(1)
                                        ) +
                                        "% "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        182846840
                      ),
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }